<template>
    <div class="energyconsumption">
          <div class="con">
                <div class="left-tree">
                      <div class="search" style="margin-bottom: 15px;">
                            <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                       </div>
                      <el-scrollbar style="height:calc(100% - 45px);width: 100%">
                        <el-tree
                          :data="companyData"
                          node-key="unitNo"
                          :props="defaultPropsCompany"
                          :filter-node-method="filterNode"
                          default-expand-all
                          @node-click="nodeClick"
                          ref="Companytree">
                            <span class="custom-tree-node" slot-scope="{node}" style="display: flex;align-items: center;">
                              <img src="../../../public/static/image/elTree/1.9.png"/>
                                <span style="padding-left: 5px;" >{{node.data.name}}</span>
                              </span>
                        </el-tree>
                        
          
                      </el-scrollbar>
                </div>
                <div class="right-table">
                     <div class="Files-top">
                        <div class="ic-left">
                          <span>能耗配置</span>
                        </div>
                        <div class="btns">
                        </div>
                      </div>
                      <div class="table-devtree">
                            <div class="mytable">
                              <el-table
                                  ref="multipleTable" :data="deviceTableData" v-loading='loading'  tooltip-effect="dark" style="width: 100%" :height="heights" border
                                  @selection-change="handleSelectionChange">
                                  <template slot="empty">
                                      <span class="noData">
                                        <img src="@/assets/noData.png" alt="暂无数据">
                                        <span class="text">暂无数据</span>
                                      </span>
                                    </template>
                                  <el-table-column  width="90" label="序号" align="center">
                                    
                                    <template slot-scope="scope">
                                        <span>{{ scope.$index + 1 }}</span>
                                    </template>
                                    </el-table-column>
                                  <el-table-column   type="selection"   width="44"  align="center"> </el-table-column>
                                  <el-table-column  label="设备号"  prop="deviceno" min-width="300"></el-table-column>
                                  <el-table-column  prop="devicename" label="设备名称"  min-width="300"></el-table-column>
                              </el-table>
                            </div>
                             <div class="dra-btns">
                               <div class="left-add" @click="saveDevice">添加<img src="@/assets/left.png" alt=""></div>
                               <div class="del" @click="device_Del">移除<img src="@/assets/right.png" alt=""></div>
                             </div>
                              <div class="dev-tree" style="width:300px;hieght:100%">
                               <div class="search">
                                  <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                                </div>
                                <el-scrollbar style="height:calc(100% - 60px);width: 100%;">
                                  <el-tree :data="deviceData" show-checkbox node-key="numNo" :props="defaultProps" @check="currentChecked"
                                      :filter-node-method="filterNode2"  ref="tree" >
                                      <span class="custom-tree-node" slot-scope="{node}">
                                        <img src="../../../public/static/image/elTree/1.9.png"  v-show="node.data.Content.Category=='Organization'"/>
                                         <img src="../../../public/static/image/elTree/2.1.png"  v-show="node.data.Content.Category=='Device'"/>
                                           <span style="padding-left: 5px;">{{node.data.Content.Name}}</span>
                                      </span>
                                    </el-tree>
                                   
                                  </el-scrollbar>
                          </div>
                      </div>
                </div>
          </div>
    </div>
</template>
<script>
  import Pagination from "../../components/module/Pagination"; // 分页
  import {getReadDeviceTree} from "../../api/abbNewApi";
  import {loadPowerSaveLoadPower,loadPowerDeleteLoadPower,findLoadPowerByGroupNo} from "../../api/loadPower";
  export default {
    components: { Pagination },
    data() {
      return {
         heights: document.getElementById('app').clientHeight-200,//屏幕高度 - 导航栏高度
        mainId: '',
        topLevel:0,
        deviceName:"",
        searchName:"",
          multipleSelection: [],
          deviceTableData:[],
          companyData:[],
          checkedNodes:[],
        filterText: '',
          deviceData:[],
          defaultProps: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
         defaultPropsCompany: {
          children: 'next',
          label: 'name'
        },
        checkName:"",
        deviceDataCopy:[],
        loading:false

      };
    },
    mounted() {
        // console.log("打卡时间内", this.$store.unitStore.getters.getUnitTree);
        this.companyData = [this.$store.unitStore.getters.getUnitTree]
       
       //获取设备树
       var num = 0
       getReadDeviceTree().then(res => {
          var recursiveFunction = function(){
							const getStr = function(list){
								list.forEach(function(row){
									if(row.ChildDatas.length != 0){
										// console.log("row.ChildDatas",row);
                    row.numNo = num++
										getStr(row.ChildDatas)
									}else {
                    row.numNo = num++
                       row['disabled'] = false
									}
								})
							}
							getStr(res.data)
						}
						recursiveFunction()
        this.deviceData = res.data
        // this.deviceDataCopy = JSON.parse(JSON.stringify(this.deviceData))
        // this.companyData = res.data
        // console.log("设备列表",this.deviceData);
      })
    },
    methods: {
        //单位树点击事件
        nodeClick(item){
            // console.log(item);
            this.mainId = item.unitNo
              this.checkName = item.name
        //       var a = this.deviceDataCopy
        //       var deviceData = []
        //        var recursiveFunction = function(){
				// 			const getStr = function(list){
				// 				list.forEach(function(row){
				// 					if(row.Content.Category == 'Organization'){
        //                                 if(row.Content.Name == item.name){
        //                                     deviceData = [row]
        //                                }
				// 						getStr(row.ChildDatas)
				// 					}
				// 				})
				// 			}
				// 			getStr(a)
				// 		}
				// recursiveFunction()
        // this.deviceData = deviceData
           this.getDevice()
        },
          //树形结构选中节点
		currentChecked (nodeObj, SelectedObj) {
            this.checkedNodes = SelectedObj.checkedNodes
              this.checkedNodes =     this.checkedNodes.filter(item => item.Content.Category == 'Device')
            },
       // 绑定设备
      saveDevice() {
        if(this.checkName == ""){
          this.$message({type: 'warning',message: '请选择单位'});
           return
        }
        if(this.checkedNodes.length ==0){
          this.$message({type: 'warning',message: '请勾选设备'});
           return
        }
         var ids = ""
          this.checkedNodes.forEach(item => ids += ','+item.Id)
          ids = ids.slice(1)
        var d = {
          'appType':"power",
          "deviceNos": ids,
          "groupNo": this.mainId,
        };
        loadPowerSaveLoadPower(d).then(res => {
          // console.log(res);
          if(res.code==200){
              //  this.checkedNodes = []
               this.$message({type: 'success',message: '绑定成功'});
               this.$refs.tree.setCheckedKeys([]);
              this.getDevice()
          }else {
              this.$message({type: 'error',message: `绑定失败,${res.message}`});
          }
        })
   

      },
            //输入关键字进行过滤
       filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
         filterNode2(value, data) {
        if (!value) return true;
       return data.Content.Name.indexOf(value)!==-1;
      },
      
     
      
      
        //移除分项的关联设备
      device_Del(){
         if(this.checkName == ''){
           this.$message({type: 'warning',message: '请选择单位'});
           return
        }
        // console.log("this.multipleSelection",this.multipleSelection);
          if( this.multipleSelection.length ==0){
               this.$message({type: 'warning',message: '请勾选需要删除的设备!'});
               return
          }
          var ids = ""
          this.multipleSelection.forEach(item => ids += ','+item.id)
          // console.log(ids.split(1));
          ids = ids.slice(1)
            //  'subitemId':this.mainId,
          var d = {
            'loadPowerId':ids
          }
          loadPowerDeleteLoadPower(d).then(res => {
            // console.log("移除",res);
             if(res.code ==200){
               this.$message({type: 'success',message: '移除成功!'});
               this.getDevice()
             }else {
              this.$message({type: 'error',message: `移除失败,${res.message}`});
             }
          })

      },
       //搜索设备列表
      search_fn(){

      },
      
      
      // 获取绑定列表
      getDevice() { 
         var d = {
            "appType":"power",
            'groupNo':this.mainId
         }
         this.loading = true
         findLoadPowerByGroupNo(d).then(res => {
            // console.log("绑定列表res",res);
             this.loading = false
            if(res.code ==200){
                 this.deviceTableData = res.data
                var   a = this.deviceData
                    var recursiveFunction = function(){
							  const getStr = function(list){
								list.forEach(function(row){
									if(row.ChildDatas.length != 0){
                    getStr(row.ChildDatas)
									}else {
                    row.disabled = false
                    res.data.forEach(item => {
                      if(row.Content.Id == item.deviceno){
                        // console.log("row.ChildDatas",row);
                        row.disabled = true
                      }
                    })
 
									}
								})
							}
							getStr(a)
						}
						recursiveFunction()
            }
         })
          
      },
      // 勾选
      handleSelectionChange(val) {
          this.multipleSelection = val;
      },

      
    },
    watch:{
      filterText (val) {
        this.$refs.Companytree.filter(val);
      },
    },
  };
</script>

<style lang="scss" scoped>
    .energyconsumption {

    display: flex;
    .table-devtree {
      display: flex;
      width: 100%;
      height: calc(100% - 35px);
      // height: 100%;
    }
    .mytable {
       width: calc(100% - 412px);
       margin-top: 20px;
    }
    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }
    .dev-tree {
      width: 300px;
      height: 100%;
      padding: 22px 12px 0px 12px;
      box-sizing: border-box;
       border-left:1px solid #ccc
    }
    .dra-btns {
   width: 88px;
   margin: 0px 12px;
   margin-top: 240px;
   .left-add,.del{
     width: 88px;
     height: 32px;
     background-color: #368ED9;
     color: #fff;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 2px;
   }
   .del {
       background-color: #ED6547;
       margin-top: 40px;
   }
}

    .left-tree {
      width: 3rem;
      height: 100%;
      flex-shrink: 0;
      overflow: hidden;
      background-color: #fff;
      padding: 12px;
      box-sizing: border-box;
      margin-right: 8px;
    }

    .input-small span {
      white-space: nowrap;
    }

    .el_Tree_Body {
      border: 0px;
    }
    /deep/.search-input-btn .el-select .el-input__inner {
      width: 1.6rem;
    }

    .search-input-btn .input-small .el-input__inner {
      width: 1.6rem;
    }

    /deep/.search-input-btn .myinput .el-input {
      width: 1.6rem;
    }

    .right-table {
      width: calc(100% - 308px);
      background-color: #fff;
      padding: 12px 20px 0px 20px;
      box-sizing: border-box;

      .Files-table {


        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table td {
          padding: 1px 0px;
          height: 44px;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .state-row {
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            display: inline-block;
            width: 9px;
            height: 9px;
            border-radius: 50%;
            margin-right: 10px;
            position: relative;
            top: -1px;
            border: 4px solid transparent;
          }
        }

        .open-state {
          color: #0DAE88;

          span {
            background-color: #0DAE88;
            border-color: #B0FFED;
          }
        }

        .close-state {
          color: #FF1D1D;

          span {
            background-color: #FF1D1D;
            border-color: #FFD7D7;
          }
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }




  }
</style>